<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-archive text-primary mr-2"></i>
                    Gestión de Departamentos
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Departamentos
                    <export-actions :rows="getDepartmentsFilteredData()"></export-actions>
                </b-row>

                <v-client-table
                    ref="departmentsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="departments"
                    :options="options"
                    :theme="theme" @filter="onFilter">

                    <template slot="uuid" slot-scope="props">
                        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                        <i
                            size="sm"
                            @click.stop="selectDepartment(props.row)"
                            class="fa fa-pencil text-primary">
                        </i>
                    </template>

                </v-client-table>
            </b-card>
        </b-row>

        <b-modal
            id="newDepartment"
            ref="newDepartment"
            :title="modalTitle"
            ok-title="Guardar"
            cancel-title="Cancelar"
            hide-footer
            v-model="show">
            <b-form @submit.prevent="store">
                <b-form-group class="w-100">
                    <label for="code"><strong>Código</strong></label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="code"
                            placeholder="Código de Departamento"
                            v-model="department.code"
                            :required="true"
                            :disabled="!!department.uuid && !!department.systemDepartment">
                            <i class="fa fa-user"></i>
                        </b-form-input>
                    </b-input-group>
                </b-form-group>
                <label for="description"><strong>Descripción</strong></label>
                <b-form-textarea
                    id="description"
                    v-model="department.description"
                    placeholder="Describa el departamento"
                    :rows="3"
                    :max-rows="6"
                    class="mb-4"
                    :required="true"
                    :disabled="!!department.uuid && !!department.systemDepartment">
                </b-form-textarea>
                <b-row class="border-top pt-3 px-3">
                    <div class="w-100 d-flex justify-content-between align-items-center">
                        <button
                            v-if="department.uuid && !department.systemDepartment && mixinCheckPermission('DEPARTMENT_DELETE')"
                            type="button"
                            @click="remove()"
                            class="btn btn-brand btn-danger col-auto mr-auto btn-lg"
                            sm="12">Eliminar
                        </button>
                        <div v-else>&nbsp</div>
                        <button
                            type="submit"
                            class="btn btn-brand btn-primary col-auto btn-lg float-right" sm="12"
                            v-if="mixinCheckPermissions(['DEPARTMENT_NEW', 'DEPARTMENT_EDIT'])"
                            :disabled="!!department.uuid && !!department.systemDepartment">
                            Guardar
                        </button>
                    </div>
                </b-row>
            </b-form>
        </b-modal>

    </div>
</template>

<script>

    import VueNotifications from 'vue-notifications';
    import Vue from 'vue';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import ExportActions from '@/components/ExportActions';

    Vue.use(ClientTable)

    export default {
        name: 'listUsers',
        components: {
            ClientTable,
            Event,
            ExportActions
        },
        mounted() {
            this.$eventHub.$on('newDepartment', obj => {
                this.flush();
                this.$refs.newDepartment.show();
            });
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.options.texts = form.tableLabels();
            this.getDepartments()
        },
        beforeDestroy() {
            this.$eventHub.$off('newDepartment');
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Inicio', path: '/admin/dashboard', brand: 'fa fa-home'},
                    {
                        name: 'Nuevo Departamento',
                        emit: 'newDepartment',
                        brand: 'fa fa-archive',
                        permissions: ['DEPARTMENT_NEW']
                    },
                ],
                action: null,
                departments: [],
                department: {
                    code: null,
                    description: null,
                    uuid: null,
                    systemDepartment: null
                },
                show: false,
                columns: ['uuid', 'code', 'description'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        code: 'Código',
                        description: 'Descripción'
                    },
                    columnsClasses: {
                        uuid: "fit"
                    },
                    sortable: ['code', 'description'],
                    filterable: ['code', 'description'],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
            }
        },
        computed: {
            modalTitle() {
                return (!!this.department.uuid ? 'Editar Departamento' : 'Crear Departamento');
            }
        },
        methods: {
            getDepartments() {
                let self = this;
                this.$_loadingMixin_showLoading();

                axios.get('departments')
                    .then(function (response) {
                        self.$_loadingMixin_hideLoading();
                        if (response.status == "200") {
                          self.departments = response.data;
                          let searchValue = this.$store.getters.getTextFilter;
                          if (searchValue === null || searchValue === '') {

                          }  else {
                            document.querySelector('.VueTables__search__input').value  = this.$store.getters.getTextFilter;
                            let filteredDepartments = []
                            response.data.map(function (e) {
                              if (e.code === searchValue || e.name.includes(searchValue)) {
                                filteredDepartments.push(e)
                              }
                            });
                            self.departments = filteredDepartments;
                          }
                        }
                    })
                    .catch(function (error) {
                        self.$_loadingMixin_hideLoading();
                        self.showErrorMsg();
                    });
            },
            remove() {
                let self = this;
                swal({
                    title: '¿Estás seguro?', text: "Esta operación no se podrá revertir", type: 'warning',
                    showCancelButton: true, cancelButtonText: 'Cancelar', confirmButtonText: 'Sí, elimínalo!'
                }).then((result) => {
                    if (result.value) {
                        axios.delete('departments/' + this.department.uuid)
                            .then(function (response) {
                                if (response.status == "200") {
                                    self.showSuccessMsg({
                                        title: 'Operación Completada',
                                        message: 'Registro eliminado con éxito'
                                    });
                                    self.flush();
                                    self.getDepartments();
                                }
                            })
                            .catch(function (error) {
                                self.showErrorMsg();
                            });
                    }
                });

                this.show = false
            },
            selectDepartment(department) {
                if (!!department.uuid) {
                    this.department.uuid = department.uuid;
                    this.department.description = department.description;
                    this.department.code = department.code;
                    this.department.systemDepartment = department.systemDepartment;
                    this.show = true;
                }
            },
            store() {
                let self = this;
                let path = "departments";
                let type = "post";
                let resp = 201;
                let option = 1;

                if (this.department.uuid) {
                    path = 'departments/' + this.department.uuid;
                    type = "put";
                    resp = 200;
                    option = 2;
                }

                this.$_loadingMixin_showLoading();
                axios({method: type, url: path, data: this.department})
                    .then(function (response) {
                        self.$_loadingMixin_hideLoading();
                        if (response.status == resp) {
                            self.show = false;
                            self.showSuccessMsg();
                            self.flush();
                            self.getDepartments();
                        }
                    })
                    .catch(function (error) {
                        self.$_loadingMixin_hideLoading();
                        self.showErrorMsg();
                    });

                this.show = false;
            },
            flush() {
                this.department.uuid = null;
                this.department.code = null;
                this.department.description = null;
                this.department.systemDepartment = null;
            },
            getRowCount(items) {
                return items.length;
            },
            hideModal() {
                this.$refs.newDepartment.hide();
            },
            getDepartmentsFilteredData() {
                if (!!this.$refs.departmentsTable) {
                    return this.$refs.departmentsTable.allFilteredData.map(department => ({
                        'Código': department.code,
                        'Descripción': department.description
                    }));
                } else {
                    return [];
                }
            },
            onFilter () {
              let _self = this;
              if (document.querySelector('.VueTables__search__input').value === '') {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                _self.getDepartments();
              } else {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
              }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación Completada',
                message: 'Departamento guardado con éxito'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Acceso denegado',
                message: 'Algo salió mal'
            }
        }
    }
</script>
